<template>
  <div class="mypage-cancel-paid-plan-edit-pane">
    <external-confirmation-section
      :title="$tc('MypagePage.common.externalConfirmation.title.web')"
      :message="$tc('MypagePage.common.externalConfirmation.message.web')"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from '@vue/composition-api'
import ExternalConfirmationSection from '@/components/common/ExternalConfirmation/ExternalConfirmationSection.vue'

/**
 * アプリ版: 有料会員解約 ペイン
 */
export default defineComponent({
  name: 'MypageCancelPaidPlanEditPane',
  components: {
    ExternalConfirmationSection,
  },
})
</script>

<style lang="scss" scoped>
.mypage-cancel-paid-plan-edit-pane {
  width: 100%;
  max-width: $responsiveMypageMaxWidth;
  height: calc(#{$mypageContentHeightHasSubHeader} - #{var(--safe-area-inset-bottom)});
  padding: 24px 0 104px;
  margin: 0 auto;
  text-align: left;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
